import type { PointData } from 'pixi.js';
import type { BoosterType } from '../../boosters/types';
import type { BlockerIntroType } from '../../blockers/constants';

export interface GameTutorialState {
  setupSteps?: GameTutorialStep[];
  steps: GameTutorialStep[];
}

export enum GameTutorialStepType {
  Move = 'move',
  Goal = 'goal',
  WaitForTileRemoval = 'waitForTileRemoval',
  BoosterUse = 'boosterUse',
  OpenBoosterPopup = 'boosterPopup',
  SetBoosterButtonLock = 'boosterButtonLock',
  OpenBlockerIntroPopup = 'blockerIntroPopup',
}

export interface GameTutorialStep {
  type: GameTutorialStepType;
}

export interface GameTutorialMoveStep extends GameTutorialStep {
  type: GameTutorialStepType.Move;
  trayX: number;
  stackX: number;
  stackY: number;
}

export interface GameTutorialGoalStep extends GameTutorialStep {
  type: GameTutorialStepType.Goal;
  text: string;
}

export interface OpenBoosterPopupStep extends GameTutorialStep {
  type: GameTutorialStepType.OpenBoosterPopup;
  boosterType: BoosterType;
  collect: boolean;
}

export interface GameTutorialBoosterUseStep extends GameTutorialStep {
  type: GameTutorialStepType.BoosterUse;
  boosterType: BoosterType;
  availableStacks: PointData[];
}

export interface GameTutorialBoosterButtonLockStep extends GameTutorialStep {
  type: GameTutorialStepType.SetBoosterButtonLock;
  boosterType: BoosterType;
  locked: boolean;
}

export interface OpenBlockerIntroPopupStep extends GameTutorialStep {
  type: GameTutorialStepType.OpenBlockerIntroPopup;
  blockerIntroType: BlockerIntroType;
}
